module.exports = __webpack_public_path__ + "static/media/customize_add_blocks_1.aa28f12d.png";